// recon-loans-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'rcn.docStatus.validForPeriod': 'Valid for the period',
  'rcn.docStatus.carriedForward': 'Carried forward to period end',
  'rcn.docStatus.needsCarryForward': 'Needs carry-forward',
  'rcn.docStatus.wrongPeriod': 'Wrong period',
  'rcn.docStatus.incomplete': 'Incomplete documentation',
  'rcn.docStatus.wrongCompany': 'Wrong company',
  'rcn.docStatus.missing': 'Missing',
  'rcn.docIssue.none': 'No objection',
  'rcn.docIssue.wrongCompany': 'Concerns the wrong company',
  'rcn.docIssue.incomplete': 'Incomplete documentation',
  'rcn.repaymentType.serial': 'Serial loan — equal principal payments',
  'rcn.repaymentType.annuity': 'Annuity loan — equal installment amounts',
  'rcn.repaymentType.interestOnly': 'Interest-only — interest payments only',
  'rcn.repaymentType.unknown': 'Unknown / other',
  'rcn.check.unregistered': 'Debt accounts without a registered loan',
  'rcn.check.documentation': 'Loans without valid documentation for the period',
  'rcn.check.plan': 'Loans without a repayment plan',
  'rcn.check.interest': 'Loans with accrued interest that has not been booked',
  'rcn.check.fees': 'Loans with fees that have not been booked',
  'rcn.check.currency': 'Loans in foreign currency',
  'rcn.check.unclassified': 'Booked debt outside short- and long-term debt',
});
